import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Shield, Sparkles } from 'lucide-react';
export function PricingCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const includes = ['Ebook completo "Florecer"', 'Bonus 1: Primeros Auxilios para Bebés', 'Bonus 2: Carpeta Prenatal', 'Bonus 3: Primeras Comidas del Bebé', 'Bonus 4: Recuperar tu cuerpo después del embarazo', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'];
  return <section id="pricing" className="py-20 md:py-28 bg-gradient-to-b from-peach-light/50 to-cream relative overflow-hidden" data-id="element-256">
      <div className="absolute top-10 right-10 grid grid-cols-4 gap-2 opacity-30" data-id="element-257">
        {[...Array(16)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-full bg-peach" data-id="element-258"></div>)}
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-259">
        <div className="text-center mb-12" data-id="element-260">
          <span className="inline-block text-xs md:text-sm font-bold tracking-[0.3em] text-peach-dark uppercase mb-4" data-id="element-261">
            ⏰ OFERTA POR TIEMPO LIMITADO
          </span>
          <h2 className="font-serif text-text-dark leading-[1.05] tracking-tight mb-4" style={{
          fontSize: 'clamp(2rem, 5vw, 4rem)'
        }} data-id="element-262">
            Precio de lanzamiento cierra en
          </h2>

          <div className="flex justify-center gap-3 md:gap-6 mt-8 mb-4" data-id="element-263">
            {[{
            val: timeLeft.hours,
            label: 'HORAS'
          }, {
            val: timeLeft.minutes,
            label: 'MIN'
          }, {
            val: timeLeft.seconds,
            label: 'SEG'
          }].map((unit, idx) => <div key={idx} className="bg-white rounded-2xl px-5 py-4 md:px-8 md:py-5 shadow-md border border-peach-light min-w-[90px] md:min-w-[110px]" data-id="element-264">
                <div className="text-4xl md:text-5xl font-serif font-bold text-peach-dark tabular-nums leading-none" data-id="element-265">
                  {formatTime(unit.val)}
                </div>
                <div className="text-xs font-bold tracking-widest text-text-muted mt-2" data-id="element-266">
                  {unit.label}
                </div>
              </div>)}
          </div>

          <p className="text-text-muted text-sm" data-id="element-267">⚠️ Después sube. No vuelve.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2.5rem] shadow-2xl shadow-peach/20 border border-peach/20 overflow-hidden relative" data-id="element-268">
          <div className="absolute top-6 right-6 md:top-10 md:right-10 w-20 h-20 md:w-24 md:h-24 bg-peach text-white rounded-full flex flex-col items-center justify-center shadow-xl transform rotate-12 z-20" data-id="element-269">
            <span className="text-2xl md:text-3xl font-bold leading-none" data-id="element-270">
              50%
            </span>
            <span className="text-xs font-bold tracking-widest mt-1" data-id="element-271">OFF</span>
          </div>

          <div className="bg-peach text-white text-center py-4 text-sm font-bold tracking-widest uppercase flex items-center justify-center gap-2" data-id="element-272">
            <Sparkles className="w-4 h-4" data-id="element-273" /> OFERTA ESPECIAL
          </div>

          <div className="p-8 md:p-12" data-id="element-274">
            <div className="text-center mb-8 pb-8 border-b border-peach-light" data-id="element-275">
              <h3 className="font-serif italic text-peach-dark mb-2" style={{
              fontSize: 'clamp(2.5rem, 6vw, 4.5rem)'
            }} data-id="element-276">
                Florecer
              </h3>
              <p className="text-text-muted mb-6" data-id="element-277">
                6 capítulos + 4 bonus exclusivos
              </p>

              <div className="flex justify-center items-center gap-3 text-text-muted line-through text-lg md:text-xl mb-2" data-id="element-278">
                <span data-id="element-279">$39.980</span>
                <span data-id="element-280">+</span>
                <span data-id="element-281">$42.500</span>
              </div>

              <div className="flex justify-center items-end gap-2 text-text-dark" data-id="element-282">
                <span className="text-6xl md:text-8xl font-bold tracking-tight" data-id="element-283">
                  $19.990
                </span>
                <span className="text-xl font-medium mb-3" data-id="element-284">ARS</span>
              </div>
              <p className="text-sm text-text-muted mt-4" data-id="element-285">
                Pago único · Acceso de por vida
              </p>
            </div>

            <div className="mb-10" data-id="element-286">
              <h4 className="text-xs font-bold tracking-[0.3em] text-text-dark uppercase mb-6 text-center" data-id="element-287">
                INCLUYE TODO ESTO
              </h4>
              <ul className="space-y-4 max-w-md mx-auto" data-id="element-288">
                {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-289">
                    <span className="text-peach shrink-0 mt-0.5" data-id="element-290">🌸</span>
                    <span className="text-text-dark" data-id="element-291">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="text-center" data-id="element-292">
              <a href="https://checkout.aula-mater.online/cart/66753447428141:1" className="inline-flex justify-center items-center w-full md:w-auto px-12 py-5 bg-peach text-white font-bold rounded-full hover:bg-peach-dark transition-colors shadow-xl shadow-peach/30 text-xl mb-6 tracking-wide" data-id="element-293">
                QUIERO MI ACCESO AHORA
              </a>

              <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-sm text-text-muted" data-id="element-294">
                <span className="flex items-center gap-1" data-id="element-295">
                  <Shield className="w-4 h-4" data-id="element-296" /> Pago seguro
                </span>
                <span className="hidden sm:inline text-peach/30" data-id="element-297">•</span>
                <span className="flex items-center gap-1" data-id="element-298">
                  <Clock className="w-4 h-4" data-id="element-299" /> Acceso en 5 min
                </span>
                <span className="hidden sm:inline text-peach/30" data-id="element-300">•</span>
                <span data-id="element-301">Garantía 7 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}